import React from "react";
import "./UploadMediaListItem.css";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { toast } from "react-toastify";
import ProgressBar from "react-bootstrap/ProgressBar";
import Badge from "react-bootstrap/Badge";
import { connect } from "react-redux";
import {
  removeMediaItemAction,
  modifyUploadItemAction
} from "../../redux/actions/issueMediaUploader";
import { deleteMediaApi, saveMediaMetaApi } from "../../api/issues";

class UploadMediaListItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleSaveClicked = this.handleSaveClicked.bind(this);
    this.handleDeleteClicked = this.handleDeleteClicked.bind(this);
    this.handleDescriptionEntered = this.handleDescriptionEntered.bind(this);
    this.handleTitleEntered = this.handleTitleEntered.bind(this);
    this.thumbClicked = this.thumbClicked.bind(this);

    const { serverData, filename } = this.props;

    try {
      this.state = {
        selectThumbID:
          serverData.thumbnail == null ? null : serverData.thumbnail.id,
        saveLoading: false,
        deleteLoading: false,
        title: serverData.title == null ? "" : serverData.title,
        description:
          serverData.description == null ? "" : serverData.description
      };
    } catch (e) {
      this.state = {
        selectThumbID: null,
        saveLoading: false,
        deleteLoading: false,
        title: filename == null ? "" : filename,
        description: ""
      };
    }
  }

  thumbClicked(id) {
    this.setState({ selectThumbID: id });
  }

  async handleSaveClicked() {
    let uploadState = this.getCurrentUploadState();

    if (uploadState === -1 && uploadState === -2 && uploadState === 4) {
      return;
    }

    const {
      serverData,
      uploadID,
      mediaType,
      modifyUploadItemAction
    } = this.props;

    this.setState({ saveLoading: true });

    try {
      const newServerData = {
        ...serverData,
        title: this.state.title,
        description: this.state.description,
        thumbnail: { id: this.state.selectThumbID }
      };

      await saveMediaMetaApi(
        serverData.id,
        mediaType === "video",
        newServerData
      );
      modifyUploadItemAction({ id: uploadID, serverData: newServerData });
      toast.success("success");
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ saveLoading: false });
  }

  handleDeleteClicked() {
    let uploadState = this.getCurrentUploadState();

    if (uploadState !== -2 && uploadState !== 2 && uploadState !== 4) {
      return;
    }

    const {
      serverData,
      filename,
      removeMediaItemAction,
      uploadID,
      mediaType
    } = this.props;
    const name = serverData == null ? filename : serverData.title;

    if (serverData == null) {
      removeMediaItemAction({ id: uploadID });
    } else {
      if (window.confirm("Delete " + name + "?") !== true) {
        return;
      }

      this.deleteAsync(serverData.id, mediaType === "video");
    }
  }

  async deleteAsync(id, isVideo) {
    this.setState({ deleteLoading: true });

    const { uploadID, removeMediaItemAction } = this.props;

    try {
      await deleteMediaApi(id, isVideo);
      removeMediaItemAction({ id: uploadID });
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ deleteLoading: false });
  }

  handleTitleEntered(event) {
    let uploadState = this.getCurrentUploadState();

    if (uploadState === -1 && uploadState === -2 && uploadState === 4) {
      return;
    }

    this.setState({ title: event.target.value });
  }

  handleDescriptionEntered(event) {
    let uploadState = this.getCurrentUploadState();

    if (uploadState === -1 && uploadState === -2 && uploadState === 4) {
      return;
    }

    this.setState({ description: event.target.value });
  }

  /* 
      uploadState: 

      UPLOAD_FAIL: -2
      UPLOADING: -1

      NEW: 0
      PROGRESSING = 1
      COMPLETED = 2
      PUBLISHED = 3
      ERROR = 4
  */
  getCurrentUploadState() {
    const { serverData, progress } = this.props;

    let uploadState = -1;
    if (progress === -1) {
      uploadState = -2;
    } else if (serverData != null) {
      uploadState = serverData.state;
    }

    return uploadState;
  }

  render() {
    let uploadState = this.getCurrentUploadState();

    let border;
    let title;
    let saveDisable;
    let deleteDisable;

    switch (uploadState) {
      case 0:
        border = "warning";
        title = "Waiting for processing";
        saveDisable = true;
        deleteDisable = true;
        break;
      case 1:
        border = "warning";
        title = "Processing";
        saveDisable = true;
        deleteDisable = true;
        break;
      case 2:
        border = "success";
        title = "Processing completed";
        saveDisable = false;
        deleteDisable = false;
        break;
      case 3:
        border = "dark";
        title = "Published";
        saveDisable = false;
        deleteDisable = true;
        break;
      case 4:
        border = "danger";
        title = "Processing failed";
        saveDisable = true;
        deleteDisable = false;
        break;
      case -1:
        border = "warning";
        title = "Uploading";
        saveDisable = true;
        deleteDisable = true;
        break;
      case -2:
        border = "danger";
        title = "Upload failed";
        saveDisable = true;
        deleteDisable = false;
        break;
      default:
        border = "danger";
        title = "error";
        saveDisable = true;
        deleteDisable = true;
    }

    const { mediaType, serverData, progress } = this.props;
    const showThumb =
      mediaType === "video" &&
      uploadState >= 0 &&
      serverData.thumbnails != null &&
      serverData.thumbnails.length > 0;

    return (
      <Card className="upload_list_card">
        <Card.Header>
          <h5 className="upload_list_card_title">
            <Badge variant={border}>{title}</Badge>
          </h5>
        </Card.Header>
        <Container>
          <Row>
            <Col xs="12" sm="12" md="12" lg="12" xl="12">
              <Form.Group autoFocus controlId="uploadMediaAttrForms">
                <Form.Label className="upload_media_form_title">
                  {mediaType + " title"}
                </Form.Label>
                <Form.Control
                  value={this.state.title}
                  type="text"
                  placeholder={mediaType + " title"}
                  onChange={this.handleTitleEntered}
                />
                <Form.Label className="upload_media_form_title">
                  {mediaType + " description"}
                </Form.Label>
                <Form.Control
                  value={this.state.description}
                  type="text"
                  placeholder={mediaType + " description"}
                  onChange={this.handleDescriptionEntered}
                />
              </Form.Group>
            </Col>
          </Row>
          {showThumb && (
            <React.Fragment>
              <Row>
                <Col>
                  <hr />
                </Col>
              </Row>
              <Row>
                {serverData.thumbnails.map(aThumb => (
                  <Col key={aThumb.id} xs="4" sm="4" md="4" lg="4" xl="4">
                    <Image
                      rounded
                      onClick={() => this.thumbClicked(aThumb.id)}
                      className={
                        aThumb.id === this.state.selectThumbID
                          ? "upload_media_cover_focus"
                          : "upload_media_cover"
                      }
                      src={`${process.env.REACT_APP_API_ROOT}artworks/${
                        aThumb.id
                      }/static/thumbnail`}
                    />
                  </Col>
                ))}
              </Row>
            </React.Fragment>
          )}
        </Container>
        <Card.Footer>
          <div className="upload_list_item_btm_container">
            <div className="upload_list_item_progress_container">
              {uploadState < 0 && (
                <ProgressBar
                  className="upload_list_item_progress"
                  animated
                  now={progress == null ? 0 : progress}
                />
              )}
            </div>
            <Button
              className="upload_list_item_btm_btn"
              variant="info"
              disabled={this.state.saveLoading || saveDisable}
              onClick={this.handleSaveClicked}
            >
              {this.state.saveLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Save"
              )}
            </Button>
            <Button
              className="upload_list_item_btm_btn"
              variant="danger"
              disabled={this.state.deleteLoading || deleteDisable}
              onClick={this.handleDeleteClicked}
            >
              {this.state.deleteLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Delete"
              )}
            </Button>
          </div>
        </Card.Footer>
      </Card>
    );
  }
}

const mapState = (state, ownProps) => {
  const { issueMediaUploader } = state;
  const { uploadID } = ownProps;

  const uploadItem = issueMediaUploader.mediaDicts[uploadID];

  return uploadItem;
};

const mapDispatch = {
  removeMediaItemAction,
  modifyUploadItemAction
};

export default connect(
  mapState,
  mapDispatch
)(UploadMediaListItem);
